export default __webpack_public_path__ + "static/media/speaker.ce06617e.svg";